"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ariaTelemetryKey = exports.webChatDirectLineVersion = exports.webChatACSAdapterVersion = exports.webChatIC3AdapterVersion = exports.ic3ClientVersion = void 0;
var ic3ClientVersion = '2021.08.14.1';
exports.ic3ClientVersion = ic3ClientVersion;
var webChatIC3AdapterVersion = '0.1.0-master.2dba07b';
exports.webChatIC3AdapterVersion = webChatIC3AdapterVersion;
var webChatACSAdapterVersion = '0.0.35-beta.20';
exports.webChatACSAdapterVersion = webChatACSAdapterVersion;
var webChatDirectLineVersion = '0.15.1';
exports.webChatDirectLineVersion = webChatDirectLineVersion;
var ariaTelemetryKey = 'c7655518acf1403f93ff6b9f77942f0a-d01a02fd-6b50-4de3-a566-62eda11f93bc-7083';
exports.ariaTelemetryKey = ariaTelemetryKey;
//# sourceMappingURL=settings.js.map